import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-desglose-confeccion-hist-reetiquetado',
    templateUrl: './desglose-confeccion.component.html'
})
export class DesgloseConfeccionHistReetiquetadoComponent implements OnInit {

    @Input() confecciones;
    public confeccionesPg;

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    constructor(
        private readonly _translate: TranslateService,
    ) { }

    ngOnInit() {
      this.totalItems = this.confecciones.length;
      this.confeccionesPg = this.confecciones.slice(this.currentPage, this.itemsPerPage);
    }

    public pageChange(page) {
      this.currentPage = page - 1;
      this.confeccionesPg = this.confecciones.slice(this.currentPage * this.itemsPerPage, this.currentPage * this.itemsPerPage + this.itemsPerPage);
    }

    public itemsPerPageChange(items) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt(items);
      this.confeccionesPg = this.confecciones.slice(this.currentPage * this.itemsPerPage, this.currentPage * this.itemsPerPage + this.itemsPerPage);
    }

    public get defaultLanguage() {
        return this._translate.getDefaultLang();
    }
}